module.exports = __webpack_public_path__ + "img/1506663264.f58668d2.jpg";